import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/soldier-holding-model-house_488220-9520.jpg';

function VeteransHousingAssistance() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Veteran Housing Assistance and Homelessness Prevention" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Veteran Housing Assistance and Homelessness Prevention</h4>
              <p>
                This sub-department is focused on providing stable housing solutions and preventing homelessness among veterans.<br />
                Programs include affordable housing initiatives, emergency shelter services, and support for long-term housing stability.<br /><br />
                Our mission is to ensure that every veteran has a safe place to call home, addressing their housing needs with care and efficiency.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Affordable Housing Initiatives</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Emergency Shelter Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Long-term Housing Stability Support</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to ensuring that no veteran faces homelessness, providing comprehensive housing support and resources to meet their needs.
              </p>
            </div>
            <div>
              <Link to="/department/veterans">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default VeteransHousingAssistance;
